// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3D4vb","title":"styles_title__1tW3d","section":"styles_section__1dGTM","bulletTitle":"styles_bulletTitle__2i5cp","items":"styles_items__3eoMw"};